/* ==========================================================================
   as-yotpo-claims.js

   One page can show the same Yotpo photo twice: the proof blocks pick a few
   customer photos, and the reviews hub renders a strip of them. Both fetch
   Yotpo independently, so left alone they compete for the same best photos.

   This is the shared register that stops that. Whichever section paints a
   photo CLAIMS its review id; the other skips anything already claimed.

   Neither section can assume it runs first — the proof blocks wait on an
   IntersectionObserver, the hub loads on init — so a claim also fires an
   event. A section that has already rendered listens for it and re-renders,
   which means the outcome is the same whichever order they finish in.

   Loaded by both sections; Shopify de-duplicates the tag.
   ========================================================================== */
(function () {
  'use strict';

  if (window.AsYotpoClaims) return;

  var claimed = new Set();
  var EVENT = 'as:yotpo-photos-claimed';

  window.AsYotpoClaims = {
    /* Take ownership of one or more review ids. Returns true when anything
       new was actually added, so a caller can skip a pointless re-render. */
    claim: function (ids) {
      var list = Array.isArray(ids) ? ids : [ids];
      var added = false;

      list.forEach(function (id) {
        if (id == null) return;
        var key = String(id);
        if (claimed.has(key)) return;
        claimed.add(key);
        added = true;
      });

      if (added) {
        document.dispatchEvent(new CustomEvent(EVENT, { detail: { ids: this.all() } }));
      }

      return added;
    },

    has: function (id) {
      return id != null && claimed.has(String(id));
    },

    all: function () {
      return Array.from(claimed);
    },

    /* Re-run `handler` whenever the set grows. */
    subscribe: function (handler) {
      document.addEventListener(EVENT, handler);
      return function () {
        document.removeEventListener(EVENT, handler);
      };
    }
  };
})();
